import React, { PureComponent } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { SegmentButton } from "./Common";

class SegmentComponent extends PureComponent {
  handleToggle = value => {
    const { handleChange, selectedSegment } = this.props;
    const prevSelected = [...selectedSegment];
    const index = prevSelected.indexOf(value);
    if (index > -1) {
      prevSelected.splice(index, 1);
    } else {
      prevSelected.push(value);
    }
    handleChange(prevSelected);
  };

  render() {
    const { className, options, selectedSegment } = this.props;

    return (
      <div className={className}>
        {options.map(item => (
          <SegmentButton
            onClick={() => this.handleToggle(item)}
            selected={selectedSegment.includes(item)}
            key={item}
            className=""
          >
            {item}
          </SegmentButton>
        ))}
      </div>
    );
  }
}

SegmentComponent.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  handleChange: PropTypes.func,
  selectedSegment: PropTypes.arrayOf(PropTypes.string)
};

SegmentComponent.defaultProps = {
  className: "",
  options: [],
  handleChange: () => {},
  selectedSegment: []
};
export const Segments = styled(SegmentComponent)`
  display: flex;
  .border_color {
    border: 1px solid
      ${/* istanbul ignore next */ ({ theme }) => theme.palette.SELECTED};
  }
`;
